import {formDataRequest, getRequest, postRequest} from '../libs/AxiosService.util';

export async function serviceCreateZone(params) {
    return await formDataRequest('cadres/create', params);
}
export async function serviceUpdateZone(params) {
    return await formDataRequest('cadres/update', params);
}

export async function serviceGetZone(params) {
    return await postRequest('sales/target/region/comparison', params);
}

export async function serviceGetZoneDetails(params) {
    return await postRequest('cadres/detail', params);
}

export async function serviceDeleteZone(params) {
    return await formDataRequest('cadres/delete', params);
}
